module.exports = __webpack_public_path__ + "static/media/instagram.e97e8372.svg";